import styled from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';
import { FavoritesStatus } from '../../bdcoreCandidates/Favorites';

export default styled(FavoritesStatus)`
  .FavoritesStatus {
  }
  .FavoritesStatus-active {
    @media (min-width: 992px) {
      display:inline-block;
      position:fixed;
      bottom:0;
      left:0;
      padding:10px;
      background: ${colors.brand3};
      z-index:5;
    }
  }
  .FavoritesStatus_icon {
    margin: 0 3px 0 0;
  }
  .FavoritesStatus_totalCount {
    display:none;
    color: ${colors.white};
    @media (min-width: 992px) {
      display:inline-block;
    }
  }
  .FavoriteUser {
    color: ${colors.white};
    display:none;
    margin: 0 0 0 7px;
    @media (min-width: 992px) {
      display:inline-block;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoritesStatus.js